import { CascadiaModalTriggerProps } from "@certn/cascadia";
import {
  ActionListItem,
  LinkButton,
  ModalTrigger,
  Text,
} from "@certn/cascadia-react";
interface Props {
  title: string;
  link: string;
  description: string;
  testID?: string;
  children: CascadiaModalTriggerProps["children"];
}

export function ActionListItemWithModal(props: Props) {
  const { testID = "action-list-modal-trigger-button" } = props;

  return (
    <ActionListItem
      displayAccessibility
      title={props.title}
      trailing={
        <ModalTrigger
          trigger={
            <LinkButton
              linkStyle="monochrome"
              textStyle="global/body-secondary-link"
              textColor="text-weak"
              testID={testID}
            >
              {props.link}
            </LinkButton>
          }
        >
          {props.children}
        </ModalTrigger>
      }
    >
      <Text style="form/body-secondary" color="text-weak">
        {props.description}
      </Text>
    </ActionListItem>
  );
}
